import { FilterFieldDescriptor } from '@totem/types/common';

export const TICKETING_FILTER_DESCRIPTORS: FilterFieldDescriptor[] = [
  { inputKey: 'ids', backendField: '_id' },
  { inputKey: 'regionId', backendField: 'regionId' },
  { inputKey: 'buildingId', backendField: 'buildingId' },
  { inputKey: 'controlSystemId', backendField: 'controlSystemId' },
  { inputKey: 'deviceId', backendField: 'deviceId' },
  { inputKey: 'queueId', backendField: 'queueId' },
  { inputKey: 'type', backendField: 'type' },
  { inputKey: 'status', backendField: 'status' },
  { inputKey: 'category', backendField: 'category' },
  { inputKey: 'subCategory', backendField: 'subCategory' },
  { inputKey: 'impact', backendField: 'impact' },
  { inputKey: 'urgency', backendField: 'urgency' },
  { inputKey: 'priority', backendField: 'priority' },
  { inputKey: 'reference', backendField: 'keys' },
  {
    inputKey: 'ticketNumber',
    backendField: 'number',
    operator: 'contains',
    isSingleValue: true,
  },
  { inputKey: 'favorites', backendField: 'favorites' },
];
